<template>

<div>

	<!-- show loading indicator -->
	<loading-indicator :loading="isLoading"></loading-indicator>

	<template v-if="!isLoading">

		<!-- page-heading -->
		<page-heading :show="true" :pageTitle="title"></page-heading>

		<div class="columns">

			<div class="col-main">

				<!-- ADMIN VIEW -->
				<template v-if="userRole != 'Industriepartner'">

					<tabs type="boxed" size="normal" :on-tab-click="tabClicked" :class="[{ 'APPROVED': product.status == productStatus.APPROVED.id }, 'has-status']">

						<!-- TAB: PRODUKT -->
						<tab-item label="Produkt">

							<div class="columns">

								<div class="column is-8">

									<template v-if="userRole != 'Industriepartner'">

										<div class="control is-horizontal">
											<div class="control-label">
												<label-name labelKey="PRODUCT_STATUS"></label-name>
											</div>
											<div class="control">
												<span class="select is-medium">
													<select v-model="product.status" :class="{'is-disabled': isReadOnly }">
														<option v-for="status in productStatus" :value="status.id" :class="status.name">
															{{ $t('SELECT_BOX-PRODUCT_STATUS-' + status.name) }}
														</option>
													</select>
												</span>
											</div>
										</div>

										<div class="control is-horizontal">
											<div class="control-label">
												<label-name labelKey="PRODUCT_DISPLAY_TYPE"></label-name>
											</div>
											<div class="control">
												<span class="select is-medium">
													<select v-model="product.displayType" :class="{'is-disabled': isReadOnly}">
														<option v-for="displayType in productDisplayTypes" :value="displayType.id">
															{{ $t('SELECT_BOX-PRODUCT_DISPLAY_TYPE-' + displayType.name) }}
														</option>
													</select>
												</span>
											</div>
										</div>

										<br />

										<div class="control is-horizontal">
											<div class="control-label">
												<label-name labelKey="PRODUCT_MANUFACTURER"></label-name>
											</div>
											<div class="control">
												<span class="select is-medium">
													<select v-model="product.manufacturer" :class="{'is-disabled': isReadOnly}">
														<option :value="null">Hersteller wählen ...</option>
														<option v-for="manufacturer in manufacturers" :value="manufacturer.id">{{ manufacturer.name }}</option>
													</select>
												</span>
											</div>
										</div>


										<!--
										<div class="control is-horizontal">
											<div class="control-label">
												<label-name labelKey="PRODUCT_CONTACT_PERSON"></label-name>
											</div>
											<div class="control">
												<textarea id="PRODUCT_CONTACT_PERSON" :class="[{'is-disabled': isReadOnly}, 'textarea is-medium']" type="text" v-model="product.contactPersonData"></textarea>
											</div>
										</div>
									-->


					         <form-input inputType="textarea" textareaRows="2" label="PRODUCT_CONTACT_PERSON" inputSize="is-medium" v-model="product.contactPersonData" :isReadOnly="isReadOnly" :isHorizontal="true"></form-input>

										<form-input inputType="text" label="PRODUCT_CONTACT_PERSON_EMAIL" inputSize="is-medium" v-model="product.contactPersonEmail" :isReadOnly="isReadOnly" :isHorizontal="true"></form-input>

										<!--
										<div class="control is-horizontal">
											<div class="control-label">
												<label-name labelKey="PRODUCT_CONTACT_PERSON_EMAIL"></label-name>
											</div>
											<div class="control">
												<input id="PRODUCT_CONTACT_PERSON_EMAIL" :class="[{'is-disabled': isReadOnly}, 'input is-medium']" type="text" v-model="product.contactPersonEmail"></input>
											</div>
										</div>
										-->

										<br />
										<br />

									</template>


									<div class="control is-horizontal">
										<div class="control-label">
											<label-name labelKey="PRODUCT-UPLOAD_FILE_BOX"></label-name>
										</div>
										<div class="control">

											<vue-dropzone
                        ref="vueDropzoneProduct"
                        id="vueDropzoneProduct"
                        url= "fileProcessing/upload?preset=product"
                        acceptedFiles=".jpg,.jpeg,.png"
                        dictDefaultMessage="<i class='fa fa-cloud-upload'></i>Produktbild hochladen"
                      	v-on:vdropzone-success="dzProductSuccess($event, product.id)"
                        dzClass="default">
                    	</vue-dropzone>

										</div>
									</div>

									<template v-if="product.productAssets">

										<div class="control is-horizontal">

											<div class="control-label"></div>

											<div class="control">
												<assets :assets="product.productAssets" :product="product" @removeAsset="removeImageAsset"></assets>
											</div>
										</div>

									</template>


									<!-- FOR TYPE PLACEMENT, HAUSAPOTHEKE, NEU_AM_MARKT ONLY -->
									<!-- <template v-if="[productDisplayTypes.PLACEMENT.id, productDisplayTypes.HAUSAPOTHEKE.id, productDisplayTypes.NEU_AM_MARKT.id].includes(product.displayType)"> -->
									<template v-if="productDisplayTypes.PLACEMENT.id == product.displayType">

										<div class="control is-horizontal">

											<div class="control-label">
												<label-name labelKey="PRODUCT_HEADLINE"></label-name>
											</div>

											<!-- pTitle -->
											<div class="control">
												<quill-editor
													v-model="product.title"
													ref="quillEditor1"
													:options="editorOptionSmall"
													class="quillSmall1"
													key="quill1">
												</quill-editor>
											</div>

										</div>

										<transition name="fade" appear>
											<div class="control is-horizontal counter" v-if="product.title">
												<div class="control-label"></div>
												<div class="control">
													<input-counter :inputData.sync="product.title" :limit="90"></input-counter>
												</div>
											</div>
										</transition>

										<div class="control is-horizontal">

											<div class="control-label">
												<label-name labelKey="PRODUCT_DESCRIPTION"></label-name>
											</div>

											<div class="control">

												<div class="control">
													<quill-editor
														v-model="product.description"
														ref="quillEditor2"
														:options="editorOption"
														key="quill2">
													</quill-editor>
												</div>

											</div>

										</div>

										<transition name="fade" appear>
											<div class="control is-horizontal counter" v-if="product.description">
												<div class="control-label"></div>
												<div class="control">
													<input-counter :inputData="stripHTML(product.description)" :limit="600"></input-counter>
												</div>
											</div>
										</transition>

										<br />

									</template>

									<!-- HAUSAPOTEKE -->
									<template v-else-if="productDisplayTypes.HAUSAPOTHEKE.id == product.displayType">
										<div class="control is-horizontal">

											<div class="control-label">
												<label-name labelKey="PRODUCT_HEADLINE"></label-name>
											</div>

											<!-- pTitle -->
											<div class="control">
												<quill-editor
													v-model="product.hausapoTitle"
													ref="quillEditor1"
													:options="editorOptionSmall"
													class="quillSmall1"
													key="quill1">
												</quill-editor>
											</div>

										</div>

										<transition name="fade" appear>
											<div class="control is-horizontal counter" v-if="product.hausapoTitle">
												<div class="control-label"></div>
												<div class="control">
													<input-counter :inputData.sync="product.hausapoTitle" :limit="90"></input-counter>
												</div>
											</div>
										</transition>

										<div class="control is-horizontal">

											<div class="control-label">
												<label-name labelKey="PRODUCT_DESCRIPTION"></label-name>
											</div>

											<div class="control">

												<div class="control">
													<quill-editor
														v-model="product.hausapoText"
														ref="quillEditor2"
														:options="editorOption"
														key="quill2">
													</quill-editor>
												</div>

											</div>

										</div>

										<transition name="fade" appear>
											<div class="control is-horizontal counter" v-if="product.hausapoText">
												<div class="control-label"></div>
												<div class="control">
													<input-counter :inputData="stripHTML(product.hausapoText)" :limit="600"></input-counter>
												</div>
											</div>
										</transition>

										<br />
									</template>

									<!-- NEU AM MARKT -->
									<template v-else-if="productDisplayTypes.NEU_AM_MARKT.id == product.displayType">
										<div class="control is-horizontal">

											<div class="control-label">
												<label-name labelKey="PRODUCT_HEADLINE"></label-name>
											</div>

											<!-- pTitle -->
											<div class="control">
												<quill-editor
													v-model="product.neuAmMarktTitle"
													ref="quillEditor1"
													:options="editorOptionSmall"
													class="quillSmall1"
													key="quill1">
												</quill-editor>
											</div>

										</div>

										<transition name="fade" appear>
											<div class="control is-horizontal counter" v-if="product.neuAmMarktTitle">
												<div class="control-label"></div>
												<div class="control">
													<input-counter :inputData.sync="product.neuAmMarktTitle" :limit="90"></input-counter>
												</div>
											</div>
										</transition>

										<div class="control is-horizontal">

											<div class="control-label">
												<label-name labelKey="PRODUCT_DESCRIPTION"></label-name>
											</div>

											<div class="control">

												<div class="control">
													<quill-editor
														v-model="product.neuAmMarktText"
														ref="quillEditor2"
														:options="editorOption"
														key="quill2">
													</quill-editor>
												</div>

											</div>

										</div>

										<transition name="fade" appear>
											<div class="control is-horizontal counter" v-if="product.neuAmMarktText">
												<div class="control-label"></div>
												<div class="control">
													<input-counter :inputData="stripHTML(product.neuAmMarktText)" :limit="600"></input-counter>
												</div>
											</div>
										</transition>

										<br />
									</template>


									<!-- FOR TYPE ADVICE ONLY -->
									<template v-else-if="product.displayType == productDisplayTypes.ADVICE.id">

										<div class="control is-horizontal">

											<div class="control-label">
												<label-name labelKey="PRODUCT_PRODUCT_ADVICE_TITLE"></label-name>
											</div>

											<div class="control">

												<div class="control">
													<quill-editor
														v-model="product.productAdviceTitle"
														ref="quillEditor3"
														:options="editorOptionSmall"
														key="quill3"
														class="quillSmall1">
													</quill-editor>
												</div>

											</div>

										</div>


										<div class="control is-horizontal">

											<div class="control-label">
												<label-name labelKey="PRODUCT_PRODUCT_ADVICE_TEXT"></label-name>
											</div>

											<div class="control">

												<div class="control">
													<quill-editor
														v-model="product.productAdviceText"
														ref="quillEditor4"
														:options="editorOption"
														key="quill4">
													</quill-editor>
												</div>

											</div>

										</div>

										<br />

									</template>


									<div class="control is-horizontal">

										<div class="control-label">
											<label-name labelKey="PRODUCT_NAME"></label-name>
										</div>

										<div class="control is-clearfix">

											<div class="control">
												<quill-editor
													v-model="product.displayName"
													ref="quillEditor5"
													:options="editorOptionSmall"
													key="quill5"
													class="quillSmall3">
												</quill-editor>
											</div>

										</div>

									</div>

									<div class="control is-horizontal">
										<div class="control-label">
											<label-name labelKey="PRODUCT_TYPE"></label-name>
										</div>
										<div class="control">
											<span class="select is-medium">
												<select v-model="product.type" :class="{'is-disabled': isReadOnly}">
													<option :value="null">Produkttyp wählen ...</option>
													<option v-for="productType in productTypes" :value="productType.id">{{ $t('PRODUCT_TYPE-' + productType.name) }}</option>
												</select>
											</span>
										</div>
									</div>

									<!--
									<div class="control is-horizontal">
										<div class="control-label">
											<label-name labelKey="PRODUCT_PRICE_SUPPLEMENT"></label-name>
										</div>
										<div class="control">
											<input id="PRODUCT_PRICE_SUPPLEMENT" :class="[{'is-disabled': isReadOnly}, 'input is-medium']" type="text" v-model="product.priceSupplement">
										</div>
									</div>

									<div class="control is-horizontal">
										<div class="control-label">
											<label-name labelKey="PRODUCT_PLACEMENT_CODE"></label-name>
										</div>
										<div class="control">
											<input id="PRODUCT_PLACEMENT_CODE" :class="[{'is-disabled': isReadOnly}, 'input is-medium']" type="text" v-model="product.placementCode">
										</div>
									</div>
									-->

									<!--
									<form-input inputType="select" label="PRODUCT_TYPE" :selectOptions="productTypes" inputSize="is-medium" v-model="product.type" :isReadOnly="isReadOnly" :isHorizontal="true"></form-input>
									-->




									<form-input inputType="text" label="PRODUCT_PRICE_SUPPLEMENT" inputSize="is-medium" v-model="product.priceSupplement" :isReadOnly="isReadOnly" :isHorizontal="true"></form-input>
									<form-input inputType="text" label="PRODUCT_PLACEMENT_CODE" inputSize="is-medium" v-model="product.placementCode" :isReadOnly="isReadOnly" :isHorizontal="true"></form-input>




								</div> <!--  columns is-8 -->


								<!-- PRODUCT PREVIEW -->
								<div class="column is-4 preview">

									<template v-if="product.displayType == productDisplayTypes.ADVICE.id">
										<product-tipp-preview :data="productTippPreview" :settings="{width: 100, isBordered: true, isProportional: true}" :key="product.displayType"></product-tipp-preview>
									</template>

									<template v-else>

										<product-preview
											:displayType="previewDisplayType"
											:data="product"
											:settings="{width: 100, isBordered: true, isProportional: true}"
											:key="product.displayType">
										</product-preview>

									</template>

								</div>

							</div>  <!-- columns -->


						</tab-item>


						<!-- TAB: DARREICHUNGSFORMEN -->
						<tab-item label="Darreichungsform">

							<div id="productVariantsHeader" class="columns">
								<div :class="[userRole == 'Administrator' ? 'is-3' : 'is-4', 'column']"><lang labelKey="PRODUCT_VARIANT-NAME"></lang></div>
								<div class="column is-1"><lang labelKey="PRODUCT_VARIANT-PRICE"></lang></div>
								<div class="column is-1" v-if="userRole == 'Administrator'">
									<lang labelKey="SAP_PRICE"></lang>
								</div>
								<div class="column is-narrow" style="width: 150px"><lang labelKey="PRODUCT_VARIANT-PZN"></lang></div>
								<div class="column is-1"><lang labelKey="PRODUCT_VARIANT-HAS_VOUCHER"></lang></div>
								<template v-if="voucherIsOpen">
									<div class="column is-1"><lang labelKey="PRODUCT_VARIANT-DISCOUNT"></lang></div>
									<div class="column is-narrow" style="width: 170px"><lang labelKey="PRODUCT_VARIANT-EXPIRATION_DATE"></lang></div>
									<div class="column is-narrow" style="width: 170px"><lang labelKey="PRODUCT_VARIANT-VOUCHER_IMAGE_URL"></lang></div>
								</template>
								<template v-else>
									<div class="column"></div>
								</template>
							</div>

							<div id="productVariants" v-if="product && product.productVariants.length > 0">

								<draggable v-model="product.productVariants" @end="dragComplete" :options="{ handle: '.dragHandle' }">

									<transition-group name="list-complete">

										<div v-for="(variant, index) in product.productVariants" :key="variant" class="columns is-multiline list-complete-item">

											<!-- col: name -->
											<div :class="[userRole == 'Administrator' ? 'is-3' : 'is-4', 'column']">
												<div class="control">
													<input :class="[{'is-disabled': isReadOnly}, 'input is-default']" placeholder="Bezeichnung" type="text" v-model="variant.name"></input>
												</div>
											</div>

											<!-- col: price -->
											<div class="column is-1">
												<div class="control">
													<input :class="[{'is-disabled': isReadOnly}, 'input is-default']" placeholder="Preis" type="text" v-model="variant.price" v-pointToComma="variant.price"></input>
												</div>
											</div>

											<!-- col: sourcePrice avp -->
											<div class="column is-1" v-if="userRole == 'Administrator'">
												<div class="control">
													<i class="sapPrice">{{ formatPoint2Comma(variant.sourcePrice_avp) }}</i>
												</div>
											</div>

											<!-- col: PZN -->
											<div class="column is-narrow">
												<div class="control" style="width: 150px;">
													<input :class="[{'is-disabled': isReadOnly}, 'input is-default']" placeholder="PZN" type="text" v-model="variant.extRef"></input>
												</div>
											</div>

											<!-- col: toggleButton -->
											<div class="column is-1">
												<b-switch :value="variant.voucher" type="primary" size="small" :on-change="toggleProductVariantVoucher.bind(this, index)" :disabled="userRole=='Industriepartner' || isReadOnly"></b-switch>
											</div>

											<!-- col: discount -->
											<div class="column is-1">
												<transition name="fade">
													<template v-if="variant.voucher!=null">
														<div class="control">
															<input :class="[{'is-disabled': userRole == 'Industriepartner' || isReadOnly}, 'input is-default discount']" style="max-width: 100px;" placeholder="0" type="text" v-model="variant.voucher.discount" v-pointToComma="variant.voucher.discount"></input>
														</div>
													</template>
												</transition>
											</div>

											<!-- col: expiration date -->
											<div class="column is-narrow">
												<transition name="fade">
													<template v-if="variant.voucher!=null">
														<div class="control">
															<span class="select is-default">
																<select style="max-width: 170px;" v-model="variant.voucher.catalogProductVoucherExpirationDate" :class="{'is-disabled': userRole == 'Industriepartner' || isReadOnly}">
																	<option v-for="expirationDate in expirationDates" :value="expirationDate">{{ expirationDate.name }}</option>
																</select>
															</span>
														</div>
													</template>
												</transition>
											</div>

											<!-- col: voucherImageUrl -->
											<div class="column">
												<transition name="fade">
													<template v-if="variant.voucher!=null">
														<div class="control" style="width: 100%; max-width: 170px;">
																<input :class="[{'is-disabled': userRole == 'Industriepartner' || isReadOnly}, 'input is-default discount']" placeholder="" type="text" v-model="variant.voucher.voucherImageUrl"></input>
														</div>
													</template>
												</transition>
											</div>

											<!-- col: delete -->
											<div class="column options is-narrow">

												<pop-confirm :class="[{'is-disabled': isReadOnly}, 'button is-light']" v-if="!isReadOnly" :content="$t('CONFIRMATION-DELETE_PRODUCT_VARIANT')" icon="question-circle-o" cancel-text="abbrechen" :on-ok="function() { deleteVariant(index) }">
													<span class="icon is-small"><i class="icon-ak-entfernen-2"></i></span>
												</pop-confirm>

												<div class="button is-light dragHandle" title="verschieben">
													<span class="icon is-small"><i class="icon-ak-move"></i></span>
												</div>

											</div>

											<!-- NEXT LINE (multiline) -->
											<transition name="slide-fade">

												<div v-if="variant.voucher!=null" class="productVariantDisplay column is-12">

													<div class="columns">

														<div class="column">
															<coupon :product="product" :expirationDates="expirationDates" :productVariant="variant"></coupon>
														</div>

														<div class="column" v-if="userRole != 'Industriepartner'">

															<div class="is-pulled-right">

																<vue-dropzone
			                            :ref="'vueDropzoneVoucher'+index"
			                            :id="'vueDropzoneVoucher'+index"
			                            url="fileProcessing/upload?preset=productVoucher"
																	:maxFiles="1"
																	acceptedFiles=".pdf"
																	dictDefaultMessage="<i class='fa fa-cloud-upload'></i>Preview hochladen"
																	v-on:vdropzone-removed-file="dzVoucherRemoveFile(file, error, xhr, index)"
																	v-on:vdropzone-mounted="dzVoucherInit(index)"
																	v-on:vdropzone-drop="dzVoucherDrop(index)"
																	v-on:vdropzone-success="dzVoucherSuccess($event, variant.id, index)"
																	dzClass="dzSingle coupon">
																</vue-dropzone>

																<div v-if="product.productVariants[index].voucher.preview != null" class="has-text-centered">

																	<a :href="getProductVariantPdfURL(index)" download="productVoucher.pdf" class="button is-light" style="font-size: 10px;">
																		<span class="icon is-small">
																			<i class="icon-ak-download"></i>
																		</span>
																		<lang labelKey="BTN-PRODUCT_VARIANTS-DOWNLOAD_PDF"></lang>
																	</a>

																</div>

															</div>

														</div>

													</div>
												</div>
											</transition>

										</div>

									</transition-group>
								</draggable>

							</div>

							<alert v-else :closable="false">
								<lang labelKey="PRODUCT_VARIANT-NOT_AVAILABLE"></lang>
							</alert>

							<!-- ADD NEW VARIANT -->
							<div id="newVariant" class="columns is-multiline">

								<!-- col: name -->
								<div <div :class="[userRole == 'Administrator' ? 'is-3' : 'is-4', 'column']"><input type="text" min="0" :class="[{'is-disabled': isReadOnly}, 'input is-normal']" placeholder="Name" v-model="newVariant.name"></input></div>

								<!-- col: price -->
								<div class="column is-1"><input type="text" :class="[{'is-disabled': isReadOnly}, 'input is-normal']" placeholder="Preis" v-model="newVariant.price" v-pointToComma="newVariant.price"></input></div>

								<!-- col: price -->
								<div class="column is-1" v-if="userRole == 'Administrator'">
									<div class="control"></div>
								</div>

								<!-- col: pzn -->
								<div class="column is-narrow">
									<div class="control" style="width: 150px;">
										<input :class="[{'is-disabled': isReadOnly}, 'input is-normal']" placeholder="PZN" type="text" v-model="newVariant.extRef"></input>
									</div>
								</div>

								<!-- col: toggleButton -->
								<div class="column is-1">
									<b-switch :value="newVariant.voucher" type="primary" size="small" :on-change="toggleProductNewVariantVoucher" :disabled="userRole == 'Industriepartner' || isReadOnly"></b-switch>
								</div>

								<!-- col: discount -->
								<div class="column is-1">
									<transition name="fade">
										<template v-if="newVariant.voucher!=null">
											<p class="control">
											  <input :class="[{'is-disabled': isReadOnly}, 'input is-normal']" style="max-width: 100px;" placeholder="Discount" type="text" min="0" v-model="newVariant.voucher.discount" v-pointToComma="newVariant.voucher.discount"></input>
											</p>
										</template>
									</transition>
								</div>

								<!-- col: expiration date -->
								<div class="column is-narrow">
									<transition name="fade">
										<template v-if="newVariant.voucher!=null">
											<p class="control">
												<span class="select is-default">
													<select style="max-width: 150px;" v-model="newVariant.voucher.catalogProductVoucherExpirationDate" :class="{'is-disabled': isReadOnly}">
														<option v-for="expirationDate in expirationDates" :value="expirationDate">{{ expirationDate.name }}</option>
													</select>
												</span>
											</p>
										</template>
									</transition>
								</div>

								<!-- col: voucherImageUrl -->
								<div class="column">
									<transition name="fade">
										<template v-if="newVariant.voucher!=null">
											<div class="control" style="width: 100%; max-width: 170px;">
													<input :class="[{'is-disabled': userRole == 'Industriepartner' || isReadOnly}, 'input is-default discount']" placeholder="" type="text" v-model="newVariant.voucher.voucherImageUrl"></input>
											</div>
										</template>
									</transition>
								</div>

								<!-- col: ADD -->
								<div class="column is-narrow">

									<button :class="[{'is-disabled': isReadOnly}, 'button is-normal is-blue']" @click="addVariant()">
										<span class="icon is-small"><i class="icon-ak-speichern"></i></span> hinzufügen
									</button>

								</div>

								<transition name="slide-fade">
									<div v-if="newVariant.voucher" class="productVariantDisplay column is-12">
										<div class="columns">
											<div class="column">
												<coupon :product="product" :expirationDates="expirationDates" :productVariant="newVariant"></coupon>
											</div>
										</div>
									</div>
								</transition>

							</div>

						</tab-item>


						<!-- Special Coupon -->
						<tab-item label="Spezial Coupon" v-if="userRole == 'Administrator'">

							<template v-if="product.productVariants.length > 0">

								<transition-group name="list" tag="div">

									<!-- LOOP through existing Special Counpons -->
									<div class="columns specialCoupons list-item" v-for="(productVoucher, index) in product.productVouchers" :key="productVoucher">

										<pop-confirm :content="$t('CONFIRMATION-DELETE_SPECIAL_COUPON')" icon="question-circle-o" cancel-text="abbrechen" :on-ok="function() { removeSpecialCoupon(index) }">
											<button :class="[{'is-disabled': isReadOnly}, 'removeSpecialCouponButton button is-single is-normal is-light']">
												<span class="icon is-small"><i class="icon-ak-entfernen-2"></i></span>
											</button>
										</pop-confirm>

										<div class="column is-narrow">

											<coupon :product="product" :productVariant="{ voucher: productVoucher }" :voucherName="productVoucher.title" :voucherPrice='getProductVoucherPrice(productVoucher.productVoucherProductVariants)' :voucherSubtitle="productVoucher.subtitle"></coupon>

											<div class="column" v-if="userRole != 'Industriepartner'">

												<div class="is-pulled-left">

													<vue-dropzone
														:ref="'vueDropzoneSpecialVoucher'+index"
														:id="'vueDropzoneSpecialVoucher'+index"
														url="fileProcessing/upload?preset=productVoucher"
														:thumbnailWidth="145"
														:thumbnailHeight="67"
														:maxFiles="1"
														acceptedFiles=".pdf"
														dictDefaultMessage="<i class='fa fa-cloud-upload'></i>Preview hochladen"
														v-on:vdropzone-removed-file="dzSpecialVoucherRemoveFile(file, error, xhr, index)"
														v-on:vdropzone-mounted="dzSpecialVoucherInit(index)"
														v-on:vdropzone-drop="dzSpecialVoucherDrop(index)"
														v-on:vdropzone-success="dzSpecialVoucherSuccess($event, productVoucher.id, index)"
														dzClass="dzSingle coupon">
													</vue-dropzone>

													<div v-if="productVoucher.preview != null" class="has-text-centered">

														<a :href="getSpecialVoucherPdfURL(index)" download="productVoucher.pdf" class="button is-light" style="font-size: 10px;">
															<span class="icon is-small">
																<i class="icon-ak-download"></i>
															</span>
															<lang labelKey="BTN-PRODUCT_VARIANTS-DOWNLOAD_PDF"></lang>
														</a>

													</div>

												</div>

											</div>


										</div>

										<div class="column">

											<div class="control">
												<div class="control-label">
													<label-name labelKey="PRODUCT-SPECIAL_COUPON-TITLE"></label-name>
												</div>

												<div class="control">
													<quill-editor
														v-model="productVoucher.title"
														:ref="'myQuillEditorTitle-'+index"
														:options="editorOptionSmall"
														class="quillSmall2"
														:key="'myQuillEditorTitle-'+index">
													</quill-editor>
												</div>

											</div>

											<div class="control">
												<div class="control-label">
													<label-name labelKey="PRODUCT-SPECIAL_COUPON-SUBTITLE"></label-name>
												</div>

												<div class="control">
													<quill-editor
														v-model="productVoucher.subtitle"
														:ref="'myQuillEditorSubtitle-'+index"
														:options="editorOption"
														class="quillSmall2"
														:key="'myQuillEditorSubtitle-'+index">
													</quill-editor>
												</div>

											</div>

											<div class="control">
												<div class="control-label">
													<label-name labelKey="PRODUCT-SPECIAL_COUPON-DISCOUNT"></label-name>
												</div>
												<div class="control">
													<input v-model="productVoucher.discount" v-pointToComma="productVoucher.discount" id="PRODUCT-SPECIAL_COUPON-DISCOUNT" :class="[{'is-disabled': isReadOnly}, 'input is-medium']" type="text"></input>
												</div>
											</div>

											<div class="control">
												<div class="control-label">
													<label-name labelKey="PRODUCT-SPECIAL_COUPON-EXPIRATION_DATE"></label-name>
												</div>
												<div class="control">
													<span class="select is-medium">
														<select v-model="productVoucher.catalogProductVoucherExpirationDate" :class="{'is-disabled': userRole == 'Industriepartner' || isReadOnly}">
															<option v-for="expirationDate in expirationDates" :value="expirationDate">{{ expirationDate.name }}</option>
														</select>
													</span>
												</div>
											</div>

											<div class="control">
												<div class="control-label">
													<label-name labelKey="PRODUCT-SPECIAL_COUPON-VOUCHER_IMAGE_URL"></label-name>
												</div>
												<div class="control">
														<input :class="[{'is-disabled': userRole == 'Industriepartner' || isReadOnly}, 'input is-default discount']" placeholder="" type="text" v-model="productVoucher.voucherImageUrl"></input>
												</div>
											</div>

											<div class="control" v-show="userRole != 'Industriepartner'">
												<div class="control-label">
													<label-name labelKey="PRODUCT-SPECIAL_COUPON-PRODUCT_VARIANTS"></label-name>
												</div>
												<div class="control" style="padding-top: 7px;">

													<!--
													<checkbox-group v-model="productVoucher.productVoucherProductVariants" :on-change="changeProductVoucherProductVariants">
														<checkbox v-for="(productVariant, j) in product.productVariants" :val="{ productVariant: productVariant.id }" :key="j" :checked="isProductVariantSelected(productVariant.id, productVoucher.productVoucherProductVariants)">{{ productVariant.name }}</checkbox>
													</checkbox-group>
													-->

													<checkbox v-for="productVariant in product.productVariants"
														:key="productVariant"
														:checked="isProductVariantSelected(productVariant.id, productVoucher.productVoucherProductVariants)"
														:change="function() { productVariantSelect(productVariant, productVoucher) }">
															{{ productVariant.name }}
													</checkbox>

												</div>
											</div>

										</div>

									</div>

								</transition-group>

								<!-- special Coupon Add Button -->
								<div v-if="product.productVouchers.length == 0" class="has-text-centered">
									<button class="button is-medium is-blue" @click.prevent="createSpecialCoupon()">
										<lang labelKey="BTN-PRODUCTS-ADD_NEW_SPECIAL_COUPON"></lang>
									</button>
								</div>

							</template>

							<template v-else>

								<alert icon="info-circle"><lang labelKey="PRODUCT-SPECIAL_COUPON-NOTICE_PLEASE_CREATE_VARIATIONS_FIRST"></lang></alert>

							</template>

						</tab-item>


						<!-- TAB: History -->
						<tab-item :label="LABEL_TAB_LOG" v-if="userRole=='Administrator'">

							<log-changes :history="product.changesLog"></log-changes>

						</tab-item>


					</tabs>


				</template>



				<!-- INDUSTRIEPARTNER -->
				<template v-else>

					<!-- Message Box for "Industriepartner" users only -->
					<alert type="info" :closable="true" class="infoSpecial" v-if="userRole=='Industriepartner' && product.status == productStatus.ACTIVE.id">
						<div v-html="infoTextIndustriepartner"></div>
					</alert>


					<div class="box industry">

						<!-- PRODUCT PREVIEW -->
						<div class="preview">

							<!-- show product placement / product tipp -->
							<!--
							<template v-if="product.displayType == productDisplayTypes.PLACEMENT.id">
								<product-preview :data="product" :settings="{width: 100, isBordered: true, isProportional: true}"></product-preview>
							</template>

							<template v-else-if="product.displayType == productDisplayTypes.ADVICE.id">
								<product-tipp-preview :data="productTippPreview" :settings="{width: 100, isBordered: true, isProportional: true}"></product-tipp-preview>
							</template>
						-->

							<template v-if="product.displayType == productDisplayTypes.ADVICE.id">
								<product-tipp-preview :data="productTippPreview" :settings="{width: 100, isBordered: true, isProportional: true}" :key="product.displayType"></product-tipp-preview>
							</template>

							<template v-else>

								<product-preview
									:data="product"
									:settings="{width: 100, isBordered: true, isProportional: true}"
									:key="product.displayType">
								</product-preview>

							</template>



							<!-- show coupons -->
							<template v-for="productVariant in product.productVariants" v-if="productVariant.voucher != null">

								<template v-if="productVariant.voucher != null && productVariant.voucher.preview != null">
									<img class="productVoucherImg lazy-img-fadein" v-lazy="getImageAsset(productVariant.voucher.preview)" />
								</template>

								<template v-else>
									<coupon :product="product" :expirationDates="expirationDates" :productVariant="productVariant" isBordered="true"></coupon>
								</template>

							</template>

							<!-- show special coupons -->
							<template v-if="product.productVouchers.length > 0">

								<div v-for="(productVoucher, index) in product.productVouchers" :key="index">
									<coupon :product="product" :expirationDates="expirationDates" :productVariant="{ voucher: productVoucher }" :voucherName="productVoucher.title" :voucherPrice='getProductVoucherPrice(productVoucher.productVoucherProductVariants)' :voucherSubtitle="productVoucher.subtitle" isBordered="true"></coupon>
								</div>

							</template>

						</div>

					</div>


				</template>

				<!-- COMMENTS -->
				<comments v-if="!isNewProduct" :threadID.sync="product.thread" :api="'product/'+product.id" :labelPrefix="userRole == 'Industriepartner' ? 'INDUSTRY' : ''"></comments>

			</div>


	        <div class="col-aside">

				<affix :offset="50">


					<custom-button type="blue" icon="icon-ak-speichern" name="PRODUCT_BUTTON_SAVE" :loading="isSaving" @click.native="submitForm()" :class="{'is-disabled': isReadOnly}"></custom-button>

					<!-- Print Product -->
					<custom-button name="PRODUCTS-PRINT_PRODUCTS" type="dark" icon="icon-ak-print" @click.native="printProduct()"></custom-button>

					<!-- impersonate -->
					<template v-if="userRole != 'Industriepartner' && product.manufacturer != null">
						<impersonate-button :manufacturerId="parseInt(product.manufacturer)"></impersonate-button>
					</template>


					<!-- if this product is in the current catalog, show the site and a link -->
					<div class="sidebox" v-if="inCatalogPages != false">
						<div class="heading">{{ $t("PRODUCT-PRODUCT_IS_IN_CATALOG")}}</div>

						<ul class="crossLinks">

							<li v-for="catalogPage in inCatalogPages">
								<!-- <router-link tag="span" class="pointer" :to="{ name: 'catalogPage', params: { 'catalogPageID': getCatalogPageURL(catalogPage.id) }}">Seite {{ catalogPage.sortorder }}</router-link> -->

								<!-- <small>[<router-link tag="span" class="pointer" :to="{ name: 'catalogPageElement', params: { 'catalogPageElementID': catalogPage.catalogPageElements[0].id}}">Placement</router-link>]</small> -->
								<small>[<router-link tag="span" class="pointer" :to="{ name: 'catalogPageElement', params: { 'id': catalogPage.catalogPageElements[0].id}}">Placement</router-link>]</small>
							</li>
						</ul>

					</div>


					<!-- SHOW APPROVED BUTTON for userRole "Industriepartner" -->
					<template v-if="userRole == 'Industriepartner'">

						<div class="sidebox">

							<template v-if="product.status != productStatus.APPROVED.id">
								<custom-button type="approve" icon="icon-ak-freigaben2" name="BTN-INDUSTRIEPARTNER-PRODUCT_APPROVE" :loading="isApproving" @click.native="industryPartnerApproveProduct()"></custom-button>
							</template>

							<template v-else>
								<custom-button type="approve" icon="icon-ak-freigaben2" class="is-disabled" name="BTN-INDUSTRIEPARTNER-PRODUCT_APPROVED"></custom-button>
							</template>

						</div>

					</template>

				</affix>

	        </div>

	    </div>

	</template>

</div>
</template>



<script>
import draggable from 'vuedraggable';
import productPreview from '../catalog/contentElements/contentElementProductPlacement';
import productTippPreview from '../catalog/contentElements/contentElementAdvice';
import Coupon from './Coupon';
import LogChanges from '../utils/incl-logChanges';
import comments from '../utils/incl-comments';
import vue2Dropzone from '../utils/dropzoneWrapper'
import assets from '../utils/incl-assets';

// require styles
// import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import { quillEditor } from 'vue-quill-editor'


export default {

    name: 'product',

	components: {
		vueDropzone: vue2Dropzone,
		productPreview,
		productTippPreview,
		Coupon,
		quillEditor,
		comments,
		LogChanges,
		assets,
		draggable
	},

	data() {

		return {

			editorOptionSmall: {
				modules: {
					toolbar: [
						[{ 'script': 'sub'}, { 'script': 'super' }],
						['italic'],
						['clean']
					]
				},
				readOnly: false,
				placeholder: ''
			},

			editorOption: {
				modules: {
					toolbar: [
						[{ 'size': ['small', false] }],
						[{ 'script': 'sub'}, { 'script': 'super' }],
						['italic'],
						[{ 'list': 'ordered'}, { 'list': 'bullet' }],
						['clean']
					],
					history: {
						delay: 1000,
						maxStack: 50,
						userOnly: false
					}
				},
				readOnly: false,
				placeholder: ''
			},

			product: {},
			inCatalogPages: false,
			infoTextIndustriepartner: this.$t('MSG-BOX-INDUSTRIEPARTNER-PRODUCT'),
			manufacturers: [],
			expirationDates: [],
      newVariant: {
          name: '',
          price: '',
          extRef: '',
					voucher: null,
					catalogProductVoucherExpirationDate: null,
					voucherImageUrl: '',
			},

			isNewProduct: false,
			isSaving: false,
			isApproving: false,
			isLoading: false,
			voucherIsOpen: false,
			oldProductStatus: '',
			LABEL_TAB_LOG: ''
		}
	},

	directives: {
		pointToComma(el,binding) {
			el.value = ( [el.value].toString()).replace(".", ",");
		}
	},

	filters: {
		truncate: function (text, stop, clamp) {
		    return text.slice(0, stop) + (stop < text.length ? clamp || '...' : '');
		}
	},

	computed: {

		showCommentInputField() {

			if(this.userRole != 'Industriepartner') {
				return true;
			}

			if(this.product.status == this.productStatus.APPROVED.id) {
				return false;
			}
		},

		previewDisplayType() {
				switch(this.product.displayType) {
					case 90:
						return 'PRODUCT'; break;
					case 11515:
						return 'HAUSAPOTHEKE'; break;
					case 11516:
						return 'NEU_AM_MARKT'; break;
				}
		},

		productTippPreview() {

			return [
				{ value: 'Produkt-Tipp'},
				{ product: this.product }
			];

		},

		title() {

			if(this.isNewProduct == true) {
				return 'HEADER-NEW_PRODUCT';
			} else {
				return this.product.displayName;

				// strip possibly html code and return the "clean" title
			   	// return this.stripHTML(this.product.displayName);
			}
		},

		productTypes() {
			return this.$store.getters.getTermsByTaxonomy('PRODUCT_TYPES');
		},

		productStatus() {
			return this.$store.getters.getTermsByTaxonomy('PRODUCT_STATUS');
		},

		productAssetTypes() {
			return this.$store.getters.getTermsByTaxonomy('PRODUCT_ASSET_TYPES');
		},

		productVoucherTypes() {
			return this.$store.getters.getTermsByTaxonomy('PRODUCT_VOUCHER_TYPES');
		},

		productDisplayTypes() {
			return this.$store.getters.getTermsByTaxonomy('PRODUCT_DISPLAY_TYPES');
		},

		catalogPageElementStatus() {
			return this.$store.getters.getTermsByTaxonomy('CATALOG_PAGE_ELEMENT_STATUS');
		},

		isReadOnly() {

			if(this.userRole != 'Administrator' && this.product.status == this.productStatus.APPROVED.id) {
				return true;
			}

		}

	},


	created() {

		// labels
		this.LABEL_TAB_LOG = this.$t('PRODUCT-TAB-LOG');

		// existing product - fetch the APO ID from router
		if(this.$route.params.id && Number.isInteger(parseInt(this.$route.params.id)) )
		{

			if(this.userRole == 'Industriepartner') {
				this.fetchDataIndustry();
			} else {
				this.fetchData();
			}

		}

		// new product
		else
		{
			this.isNewProduct = true;

			// fetch manufactureres for dropdown
			this.fetchManufacturers();

			// fetch expirationDates
			this.fetchExpirationDates();

			// create new product obj with default values
			this.product = {
			    name: "",
			    displayName: "",
			    title: "",
			    description: "",
			    header: null,
			    footer: null,
			    extRef: "",
		    	ean: "",
					status: this.productStatus.ACTIVE.id,
			    type: null,
			    contactPersonData: null,
			    manufacturer: null,
					productAssets: [],
					productVariants: [],
					productVouchers: [],
					displayType: this.productDisplayTypes.PLACEMENT.id
			}

		}

	},

	mounted() {

	},


	update() {

	},


	methods: {

		getAssetDownloadLink(asset) {

    	return this.$config.assets + asset.path + '/' + asset.filename;

    },

		printProduct() {

			var win = window.open('/katalog/produkte/print-'+this.product.id, '_blank');
		  win.focus();

		},

		dragComplete(evt) {

			var i=0;
			this.product.productVariants.forEach(function(variant) {
				variant.sortorder = i++;
			})

			// save
			this.submitForm();

		},

		createSpecialCoupon() {

			var newSpecialCoupon = {
				title: null,
				subtitle: null,
				discount: '',
				type: this.productVoucherTypes.CUSTOM.id,
				preview: null,
				product: this.product.id,
				catalogProductVoucherExpirationDate: this.expirationDates[0],
				voucherImageUrl: '',
				productVoucherProductVariants: [],
			};

			this.product.productVouchers.push(newSpecialCoupon);

		},

		removeSpecialCoupon(index) {

			this.product.productVouchers.splice(index,1);

		},


		getProductVoucherPrice(productVariants) {

			if(productVariants.length > 0 && productVariants[0].productVariant) {

				for(var i= 0; i < this.product.productVariants.length; i++) {

					if(this.product.productVariants[i].id == productVariants[0].productVariant) {
						// return parseFloat(this.product.productVariants[i].price);
						return this.product.productVariants[i].price;
					}

				}

			} else {

				// return parseFloat(this.product.productVariants[0].price);
				return this.product.productVariants[0].price;

			}

		},

		productVariantSelect(productVariant, productVoucher) {

			let index = productVoucher.productVoucherProductVariants.findIndex(v => v.productVariant && v.productVariant == productVariant.id);

			if(index == -1) {

				productVoucher.productVoucherProductVariants.push({
					extRef: productVariant.extRef,
					productVariant: productVariant.id,
					productVoucher: productVoucher.id
				});

			} else {

				productVoucher.productVoucherProductVariants.splice(index, 1);

			}

		},

		isProductVariantSelected(productVariantId, productVoucherProductVariants) {

			return productVoucherProductVariants.findIndex(v => v.productVariant && v.productVariant == productVariantId) > -1;

		},

		getCatalogPageURL(pageId) {

			// check if id is even or odd
			var secondPageId = (pageId % 2 == 0) ? pageId -1 : pageId +1;
			if(pageId > secondPageId) {
				return secondPageId + "-" + pageId;
			} else {
				return pageId + "-" + secondPageId;
			}

		},

		industryPartnerApproveProduct() {

			this.isApproving = true;

			// set the product status to "APPROVED"
			this.product.status = this.productStatus.APPROVED.id;

			var self = this;

			// save
			this.axios.post(this.$config.api+'product', this.product)
				.then(function(response) {

					self.isApproving = false;
					self.$notify.success({content: self.$t('MSG-SUCCESS-PRODUCT_STATUS_SUCCESSFULLY_APPROVED')});

					// set the status of all pageElements (placements), where the product was found, to status 25 (edited - layoutieren)
					// self._industryPartnerUpdatePageElementsStatus();

				}).catch(function(error) {
					self.isApproving = false;
					self.$notify.open({content: self.$t('MSG-ERROR-DATA_SAVE') + ': ' + error.message, type: 'danger'});
				});

		},

		/*
		_industryPartnerUpdatePageElementsStatus() {

			var self = this;

			this.axios.get(this.$config.api+'contentElement?include=contentElement.catalogPageElements,contentElement.contentElementData,contentElementData.product&filters[contentElementData.product]='+this.product.id)
				.then(function(response) {


					for(var i = 0; i < response.data.contentElement.length; i++)
					{
						for(var j=0; j < response.data.contentElement[i].catalogPageElements.length; j++)
						{
							// response.data.contentElement[i].catalogPageElements[j].status = self.catalogPageElementStatus.APPROVED.id;
							// set placement to status "edited" (id 25)
							response.data.contentElement[i].catalogPageElements[j].status = self.catalogPageElementStatus.EDITED.id;
						}
					}

					self._industryPartnerUpdatePageElementsStatus2(response.data.contentElement);

				}).catch(function(error) {
					console.log(error);
				});


		},

		_industryPartnerUpdatePageElementsStatus2(data) {

			var self = this;

			// save
			this.axios.put(this.$config.api+'contentElement', data)
				.then(function(response) {

					self.isApproving = false;
					self.$notify.success({content: self.$t('MSG-SUCCESS-PRODUCT_STATUS_SUCCESSFULLY_APPROVED')});

				}).catch(function(error) {
					self.isApproving = false;
					self.$notify.open({content: self.$t('MSG-ERROR-DATA_SAVE') + ': ' + error.message, type: 'danger'});
					console.log(error);
				});

		},
		*/



		getProductVariantPdfURL(index) {

			return this.$config.assets + this.product.productVariants[index].voucher.preview.path + '/' + this.product.productVariants[index].voucher.preview.filename;

		},

		getSpecialVoucherPdfURL(index) {

			return this.$config.assets + this.product.productVouchers[index].preview.path + '/' + this.product.productVouchers[index].preview.filename;

		},

		tabClicked() {

			setTimeout(function() {
				$('.previewContainer').trigger('resize');
			}, 50);

		},


		addVariant() {

			// if we clicked the (global) save button and all these obj properties are empty,
			// we're finished here
			if(this.isSaving == true && this.newVariant.name == "" && this.newVariant.price == "") {
				return true;
			}

			if(this.newVariant.name != "" && this.newVariant.price != "") {

				// make sure that we've a productVariants array
				if(!this.product.productVariants) {
					this.product.productVariants = [];
				}

				this.newVariant.product = this.product.id;
				this.newVariant.sourcePrice_avp = null;
				this.newVariant.sortorder = this.product.productVariants.length;

				// add the newVariant obj to our variants object
				this.product.productVariants.push(this.newVariant);


				// reset our newVariant obj
				this.newVariant = {
					name: '',
					price: '',
					extRef: '',
					type: this.productVoucherTypes.DEFAULT.id,
					voucher: null
				};

				this.submitForm();

			}

			else {

				// 'Bitte gib einen Name, Preis und eine PZN an!'
				this.$notify.open({content: this.$t('MSG-MISSING_FIELDS-NAME_PRICE'), type: 'warning'});
				this.isSaving = false;

			}


		},

		async deleteVariant(index) {
			const oldVariants = [...this.product.productVariants];
			this.product.productVariants.splice(index, 1);
			try {
				await this.submitForm();
			} catch (error) {
				this.product.productVariants = oldVariants;
			}
		},

		toggleProductVariantVoucher(index) {

			if(this.product.productVariants[index].voucher == null) {
				this.product.productVariants[index].voucher = {	discount: null }
				this.product.productVariants[index].voucher.catalogProductVoucherExpirationDate = this.expirationDates[0];
			} else {
				this.product.productVariants[index].voucher = null;
			}

			this.checkVoucherIsOpenState();

		},

		toggleProductNewVariantVoucher() {

			if(this.newVariant.voucher == null) {
				this.newVariant.voucher = { discount: 0 }
				this.newVariant.voucher.catalogProductVoucherExpirationDate = this.expirationDates[0];
			} else {
				this.newVariant.voucher = null;
			}

			this.checkVoucherIsOpenState();

		},

		checkVoucherIsOpenState() {

			var hasVoucher = false;

			if(this.newVariant.voucher != null) {

				hasVoucher = true;

			} else {

				if(this.product.productVariants) {

					for(var i=0; i < this.product.productVariants.length; i++) {
						if(this.product.productVariants[i].voucher != null) {
							hasVoucher = true;
							break;
						}
					}
				}

			}

			this.voucherIsOpen = hasVoucher;

		},


		// dropzone product
		// ---------------------------------------------------------------------
		dzProductSuccess(file, catId) {

			var result = JSON.parse(file.xhr.response);

			var newAsset = {
				category: catId,
				siteCatalog: this.product.id,
				asset: {
					filename: result.fileName,
					path: result.dir,
					uploadFilename: file.name
				},
				type: this.product.productAssets.length > 0 ? this.productAssetTypes.NONE.id : this.productAssetTypes.DEFAULT.id
			}

			// push newly created obj into assets Array
			this.product.productAssets.push(newAsset);

			var self = this;
			setTimeout(function() {
				self.$refs.vueDropzoneProduct.$children[0].removeFile(file);
			}, 1700)

		},


		// dropzone productVoucher
		// ---------------------------------------------------------------------
		dzVoucherInit(index) {

			if(this.product.productVariants[index].voucher.preview != null) {

				// set the url
				var url = this.$config.assets + this.product.productVariants[index].voucher.preview.path + '/thumb/' + this.product.productVariants[index].voucher.preview.filename;

				// change the extension from *.pdf to *.jpg
				url = url.substr(0, url.lastIndexOf(".")) + ".jpg";
				var mockFile = { id: 'previewImage', name: this.product.productVariants[index].voucher.preview.filename, type: "image/*", size: 123 }

				// add mockFile to our dropzone
				this.$refs['vueDropzoneVoucher'+index][0].$children[0].manuallyAddFile(mockFile, url);
			}

		},

		dzVoucherSuccess(file, voucherId, index) {

			// remove all files from dropzone first
			this.$refs['vueDropzoneVoucher'+index][0].$children[0].removeAllFiles();

			var result = JSON.parse(file.xhr.response);

			// put the new file into our preview property
			this.product.productVariants[index].voucher.preview = {
				filename: result.fileName,
				path: result.dir,
				uploadFilename: file.name
			}

			this.$forceUpdate();

			// call dzInit() to add the recently uploaded PDF to our dropzone
			this.dzVoucherInit(index);

			// save
			this.submitForm();

		},

		dzVoucherRemoveFile(file, error, xhr, index) {

			this.product.productVariants[index].voucher.preview = null;

		},

		dzVoucherDrop(index) {

            this.$refs['vueDropzoneVoucher'+index][0].$children[0].removeAllFiles();

        },

		// dropzone special productVoucher
		// ---------------------------------------------------------------------
		dzSpecialVoucherInit(index) {

			if(this.product.productVouchers[index].preview != null) {

				// set the url
				var url = this.$config.assets + this.product.productVouchers[index].preview.path + '/thumb/' + this.product.productVouchers[index].preview.filename;

				// change the extension from *.pdf to *.jpg
				url = url.substr(0, url.lastIndexOf(".")) + ".jpg";

				var mockFile = { id: 'previewImage', name: this.product.productVouchers[index].preview.filename, type: "image/*", type: 123 }

				// add mockFile to our dropzone
				this.$refs['vueDropzoneSpecialVoucher'+index][0].$children[0].manuallyAddFile(mockFile, url);
			}

		},

		dzSpecialVoucherDrop(index) {

            this.$refs['vueDropzoneSpecialVoucher'+index][0].$children[0].removeAllFiles();

        },

		dzSpecialVoucherRemoveFile(file, error, xhr, index) {

			this.product.productVouchers[index].preview = null;

		},

		dzSpecialVoucherSuccess(file, voucherId, index) {

			// remove all files from dropzone
			this.$refs['vueDropzoneSpecialVoucher'+index][0].$children[0].removeAllFiles();

			var result = JSON.parse(file.xhr.response);

			this.product.productVouchers[index].preview = {
				filename: result.fileName,
				path: result.dir,
				uploadFilename: file.name
			}

			this.$forceUpdate();

			// call dzInit() to add the recently uploaded PDF to our dropzone
			this.dzSpecialVoucherInit(index);

			// save
			this.submitForm();

		},



		// ---------------------------------------------------------------------


		removeImageAsset(payload) {

			let index = payload.index;
			this.product.productAssets.splice(index,1);

		},

		getImageAsset(preview) {

			var url = this.$config.assets + preview.path + '/thumb/' + preview.filename;

			// change the extension from *.pdf to *.jpg
			url = url.substr(0, url.lastIndexOf(".")) + ".jpg";

			return url;

		},

		submitForm() {

			this.isSaving = true;
			var self = this;

			// in case a new "darreichungsform" was added ...
			if(this.addVariant() == true) {

				if(this.product.productVariants.length > 0) {

					for(var i=0; i < this.product.productVariants.length; i++) {

						if(this.product.productVariants[i].price != null) {

							var price = this.product.productVariants[i].price;
							if (price.indexOf(',') > -1) {
								this.product.productVariants[i].price = price.replace(/,/g, '.');
							}

							if(this.product.productVariants[i].voucher && this.product.productVariants[i].voucher.discount != '' && this.product.productVariants[i].voucher.discount != null) {
								var discount = this.product.productVariants[i].voucher.discount;
								if (discount.indexOf(',') > -1) {
									this.product.productVariants[i].voucher.discount = discount.replace(/,/g, '.');
								}
							}

						}

					}
				}

			}

			// in case we've special coupons, we've to make sure that the
			// 'discount' value has a point instead of a comma
			if(this.product.productVouchers && this.product.productVouchers.length > 0 ) {

				this.product.productVouchers.forEach(function(voucher) {

					if (voucher.discount != '' && voucher.discount.indexOf(',') > -1) {
						voucher.discount = voucher.discount.replace(/,/g, '.');
					}

				})

			}

			/*********************************************************************************/

			var saveObj = JSON.parse(JSON.stringify(this.product));

			if(saveObj.displayName != "") {

				// strip all html tags for the "name"
				saveObj.name = this.stripHTML(this.product.displayName);

				// strip <p></p> tags
				// saveObj.displayName = (this.product.displayName).replace(/<\/?p[^>]*>/g, "");
				// this.product.displayName = this.stripPTags(this.product.displayName);

			}

			return this.axios.post(this.$config.api+'product?include=product.productVariants,productVariant.voucher,product.productVouchers,productVoucher.productVoucherProductVariants,productVoucher.catalogProductVoucherExpirationDate,catalogProductVoucherExpirationDate.expirationDates,productVoucher.preview&orderBy=productVariant.sortorder&timestamp='+Date.now(), saveObj)
				.then(function(response) {

					// console.log("response: ", response.data);

					self.product.id = response.data.id
					self.product.productVariants = response.data.productVariants;

					// update the status of corresponding placements
					if(self.inCatalogPages != false && self.oldProductStatus != self.product.status && (self.product.status == self.productStatus.APPROVED.id || self.product.status == self.productStatus.ACTIVE.id)) {

						self._updateProductPlacementStatus();

					} else {

						self.isSaving = false;
						self.$notify.success({content: self.$t('MSG-SUCCESS-DATA_SAVE')});

					}

					return response;

				}).catch(function(error) {

					self.isSaving = false;
					self.$notify.open({content: self.$t('MSG-ERROR-DATA_SAVE') + ': ' + error.title, type: 'danger'});
					throw error;

				});

		},


		_updateProductPlacementStatus() {

			var self = this;

			// get all placements where this product is placed
			this.axios.get(this.$config.api+'contentElement?include=contentElement.catalogPageElements,contentElement.contentElementData,contentElementData.product&filters[contentElementData.product]='+this.product.id)
				.then(function(response) {

					// loop through the placements and set the status of the placement
					if(response.data.contentElement.length > 0) {
						for(var i=0; i < response.data.contentElement.length; i++) {
							if(response.data.contentElement[i].catalogPageElements.length > 0) {
								response.data.contentElement[i].catalogPageElements[0].status = self.product.status == self.productStatus.ACTIVE.id ? self.catalogPageElementStatus.CREATED.id : self.catalogPageElementStatus.EDITED.id;
							}
						}
					}

					// save to db
					self._updateProductPlacementStatus2(response.data.contentElement);

				}).catch(function(error) {
					self.isLoading = false;
					console.log(error);
				});


		},

		_updateProductPlacementStatus2(contentElement) {

			var self = this;

			// update the contentElements with the new status
			this.axios.put(this.$config.api+'contentElement', contentElement)
				.then(function(response) {

					// update the oldProductStatus with the current product status
					self.oldProductStatus = self.product.status;

					self.isSaving = false;
					self.$notify.success({content: self.$t('MSG-SUCCESS-DATA_SAVE')});

				}).catch(function(error) {
					self.isLoading = false;
					console.log(error);
				});

		},

		fetchManufacturers() {

			var self = this;

			this.axios.get(self.$config.api + 'manufacturer?orderBy=name')
				.then(function (response) {
					self.manufacturers = response.data.manufacturer;
					self.isLoading = false;
				})
				.catch(function (error) {
					console.log(error);
				});

		},

		fetchData() {

			this.isLoading = true;
			var self = this;

			// get manufacturers
			function getManufacturers() {
				return self.axios.get(self.$config.api + 'manufacturer?orderBy=name');
			}

			// get ExpirationDates
			function getVoucherExpirationDates() {
				return self.axios.get(self.$config.api + 'catalog?include=catalog.catalogProductVoucherExpirationDates&filters[id]='+self.catalogId);
			}

			// get product
			function getProduct() {
				return self.axios.get(self.$config.api + 'product/' + self.$route.params.id + '?loadChangesLog=1&include=product.productVariants,productVariant.voucher,product.productVouchers,productVoucher.productVoucherProductVariants,productVoucher.catalogProductVoucherExpirationDate,catalogProductVoucherExpirationDate.expirationDates,productVoucher.preview,product.manufacturers,product.contactPersonData,productVariants.productVoucher,preview.asset,product.productAssets,productAsset.asset,product.contentElementData,contentElementData.contentElement,contentElement.catalogPageElements&orderBy=productVariant.sortorder')
			}

			// make the request
			this.axios.all([getProduct(), getManufacturers(), getVoucherExpirationDates()])

				.then(self.axios.spread(function (product, manufacturers, expDates) {

					product.data.productVouchers.forEach((pv) => {
						pv.productVoucherProductVariants.forEach((v) => {
							v.extRef = product.data.productVariants.find((pv) => pv.id == v.productVariant).extRef;
						})
					})

					self.product = product.data;
					self.oldProductStatus = product.data.status;
					self.manufacturers = manufacturers.data.manufacturer;
					self.expirationDates = expDates.data.catalog[0].catalogProductVoucherExpirationDates;
					self.newVariant.catalogProductVoucherExpirationDate = expDates.data.catalog[0].catalogProductVoucherExpirationDates[0];

					self.checkVoucherIsOpenState();

					self.isLoading = false;


					// check if product is in the catalog and if so, get the corrsponding page
					if(self.product.contentElementData.length > 0) {

						var contentElementIds = [];
						for(var i=0; i < self.product.contentElementData.length; i++) {
							contentElementIds.push(self.product.contentElementData[i].contentElement.id);
						}

						self._fetchCorrespondingPage(contentElementIds.join());
					}

				})).catch(function(error) {
					self.isLoading = false;
					console.log('Error: ', error.message);
				});

		},

		_setQuillReadOnly(status) {

			if(status == true) {

				this.editorOption.readOnly = true;
				this.editorOptionSmall.readOnly = true;

			} else {

				this.editorOption.readOnly = false;
				this.editorOptionSmall.readOnly = false;

			}

		},

		_fetchCorrespondingPage(ids) {

			var self = this;

			this.axios.get(this.$config.api + 'catalogPage?include=catalogPage.catalogPageElements,catalogPageElement.contentElement,contentElement.contentElementData,contentElementData.product&filters[catalogPageElements.contentElement]='+ids)
				.then(function(response) {
					self.inCatalogPages = response.data.catalogPage;
				}).catch(function(error) {

				});

		},

		fetchDataIndustry() {

			this.isLoading = true;
			var self = this;

			// get ExpirationDates
			function getVoucherExpirationDates() {
				return self.axios.get(self.$config.api + 'catalog?include=catalog.catalogProductVoucherExpirationDates&filters[id]='+self.catalogId);
			}

			// get product
			function getProduct() {
				return self.axios.get(self.$config.api + 'product/' + self.$route.params.id + '?include=product.productVariants,product.productVouchers,productVariant.voucher,productVoucher.productVoucherProductVariants,productVoucher.catalogProductVoucherExpirationDate,productVoucher.preview,product.manufacturers,product.contactPersonData,productVariants.productVoucher,preview.asset,product.productAssets,productAsset.asset,product.contentElementData,contentElementData.contentElement,contentElement.catalogPageElements');
			}

			// make the request
			this.axios.all([getProduct(), getVoucherExpirationDates()])

				.then(self.axios.spread(function (product, expDates) {

					product.data.productVouchers.forEach((pv) => {
						pv.productVoucherProductVariants.forEach((v) => {
							v.extRef = product.data.productVariants.find((pv) => pv.id == v.productVariant).extRef;
						})
					})

					self.product = product.data;
					self.expirationDates = expDates.data.catalogProductVoucherExpirationDates;
					self.checkVoucherIsOpenState();
					self.isLoading = false;

					// if product has status APPROVED, set quill editors to "readOnly"
					// if(this.product.status == this.productStatus.APPROVED.id && this.userRole != 'Administrator') {
					if(self.product.status == self.productStatus.APPROVED.id) {
						self._setQuillReadOnly(true);
					}

				})).catch(function(error) {
					self.isLoading = false;
					console.log('Error: ', error.message);
				});

		},

		fetchExpirationDates() {

			var self = this;

			this.axios.get(self.$config.api + 'catalog?include=catalog.catalogProductVoucherExpirationDates&filters[id]='+self.catalogId)
				.then(function(response) {
					self.expirationDates = response.data.catalog[0].catalogProductVoucherExpirationDates;
				}).catch(function(error) {
					console.log("Error: " + error.message);
				});

		},

		stripHTML(string) {

			var tmp = document.createElement("div");
			tmp.innerHTML = string;
			return tmp.textContent || tmp.innerText || "";

		},

	}

}

</script>


<style>
	.crossLinks {
		padding: 0 0 0 15px;
	}
	.crossLinks li {
		list-style-type: circle;
		padding: 0;
	}
	.crossLinks li small {
		text-transform: uppercase;
		font-size: 10px;
	}
	.quill-editor {
		min-width: 250px;
	    max-width: 500px;
	    width: 100%;
		margin-left: 0;
		line-height: 26px !important;
		font-size: 18px !important;
	}
	.quill-editor button {
		-webkit-user-select: none;  /* Chrome all / Safari all */
	    -moz-user-select: none;     /* Firefox all */
	    -ms-user-select: none;      /* IE 10+ */
	    user-select: none;          /* Likely future */
	}

	.ql-container {
		border-bottom-left-radius: 4px;
		border-bottom-right-radius: 4px;
		height: auto !important;
	}

	.ql-container .ql-editor {
		min-height: 25em;
		max-height: 50em;
		padding-bottom: 1em;
		line-height: 26px !important;
		font-size: 18px !important;
	}
	.ql-container .ql-editor ol,
	.ql-container .ql-editor ul {
		display: block;
		border-bottom: none;
		padding: 0;
	}

	.ql-container .ql-editor ol li,
	.ql-container .ql-editor ul li {
		padding-left: 1em;
	}

	.quill-editor.quillSmall1 .ql-container .ql-editor {
		min-height: 4.85em;
		max-height: 4.85em;
		padding-bottom: .5em;
		line-height: 26px !important;
		font-size: 18px !important;
	}
	.quill-editor.quillSmall2 {
		background: #fff;
	}
	.quill-editor.quillSmall2 .ql-container .ql-editor {
		min-height: 2.7em;
		max-height: 2.7em;
		padding-bottom: .5em;
		line-height: 26px !important;
		font-size: 18px !important;
	}
	.quill-editor.quillSmall3 .ql-container .ql-editor  {
		min-height: 5.5em;
		max-height: 5.5em;
		padding-bottom: .5em;
		line-height: 26px !important;
		font-size: 18px !important;
	}

	.sapPrice {
		display: inline-block;
		padding: 6px;
	}

	.checkbox.blu-checkbox {
		margin-right: 10px;
	}

</style>

<style scoped lang="scss">

	@import '../../assets/css/variables.scss';

	.has-status .tab-pane {
		border-top: 4px solid #fff;
	}
	.APPROVED .tab-pane {
		border-top: 4px solid $statusPrintApproved;
	}

</style>


<style scoped>

	/* OPTIONS COL */
	.column.options {
		display: flex;
		justify-content: flex-end;
	}
	.column.options .button {
		display: flex;
		justify-content: center;
		align-items: center;
		width: 25px;
		height: 25px;
	}
	.column.options .button:first-child {
		margin-right: 5px !important;
	}
	.column.options .button .icon {
		margin: 0 !important;
	}
	.column.options .button.dragHandle {
		cursor: move;
	}


	.sortable-ghost {
		opacity: .5;
		background: #C8EBFB;
	}
	.list-complete-item {
		padding: 4px;
		transition: all .3s;
	}
	.list-complete-enter, .list-complete-leave-active {
		opacity: 0;
	}

	.productVoucherImg {
		margin: 15px 0 0 0;
		width: 500px;
		height: 338.75px;
		border: 1px solid #ddd;
	}
	.list-enter-active, .list-leave-active {
		transition: all 0.3s;
	}
	.list-enter, .list-leave-to /* .list-leave-active for <2.1.8 */ {
		opacity: 0;
		transform: translateX(30px);
	}

	.columns.specialCoupons {
		background: #f9f9f9;
		position: relative;
	}

	.columns.specialCoupons .removeSpecialCouponButton {
		position: absolute;
		z-index: 999;
		right: 10px;
		top: 10px;
	}

	.checkbox.blu-checkbox {
		display: block;
		margin: 0 0 5px 0;
	}

	.productAssetTypeSelector {
		margin: 5px auto;
		text-align: center;
	}
	.productAssetTypeSelector .select {
		margin: 0 auto;
		max-width: 100px;
	}
	.productAssetTypeSelector select option {
		padding: 10px !important;
		margin: 10px !important;
	}



	#productVariantsHeader {
		border-bottom: 2px solid #eee;
		padding: 0 0 10px 0;
		margin: 0;
	}
	#productVariants {
		margin: 10px 0 25px 0;
	}
	#productVariantsHeader > .column {
		padding: 0 0 0 12px;
		font-weight: bold;
	}
	#productVariantsHeader > .column:nth-child(4) {
		padding: 0 0 0 6px;
	}
	.columns.is-multiline {
		margin: 0 0 0 0;
		padding: 2px 0;
		border-bottom: 1px dotted #eee;
	}
	.columns.is-multiline > .column {
		padding: 0 5px 0;
	}
	#productVariants .column input:not(.discount):not(:focus) {
		border: 1px solid transparent;
		cursor: pointer;
	}
	#productVariants .column {
		display: flex;
		align-items: center;
	}

	.productVariantDisplay {
		border-bottom: 1px solid #efefef;
		border-top: 1px solid #efefef;
		background-color: #f8f8f8;
		padding: 25px !important;
		margin: 5px 0 25px 0 !important;
	}
	.productVariantDisplay img {
		width: 120px;
		border: 1px solid #ddd;
	}
	.productVariantDisplay .description {
		padding-left: 20px;
		font-size: 1.2rem;
	}
	.productVariantDisplay .description .discount {
		font-weight: bold;
	}

	#newVariant {
		margin: 0;
		padding: 0;
		border: none;
	}
	#newVariant .column {
		margin: 0;
		padding: 0 5px;
		display: flex;
		align-items: center;
	}


	textarea#PRODUCT_DESCRIPTION {
		min-height: 500px !important;
	}
	textarea#PRODUCT_NAME,
	textarea#PRODUCT_CONTACT_PERSON {
		min-height: 74px;
	}
	textarea#PRODUCT_HEADLINE {
		min-height: 100px;
	}
	.textarea.is-medium  {
		line-height: 26px;
	}
	.select.is-medium select {
		width: 500px;
	}

	.control.counter {
		margin: 0 0 25px 0;
	}
	.control.counter > .control {
		justify-content: flex-end;
		font-size: 12px;
	}
	.columns { margin-bottom: 25px; }

	.industry > .preview {
		min-width: 400px !important;
		max-width: 600px;
		margin: 0 auto;
	}
	.industry .couponWrapper {
		margin: 20px 0 0 0;
	}
</style>
